<header class="app-header" role="banner">
      <div class="app-header__container">
        <div class="app-header__left">
          <button
            class="menu-toggle"
            (click)="toggleSidebar()"
            title="Toggle menu"
            aria-label="Toggle navigation menu"
            aria-expanded="false"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
          <h1 class="app-header__title">AskLab</h1>
          <p class="app-header__subtitle">Enterprise Dashboard</p>
        </div>

        <nav class="app-header__right" aria-label="User menu">
          @if (currentUser$ | async; as currentUser) {
            <div class="user-info" [attr.aria-label]="'Logged in as ' + currentUser.name">
              <div class="user-info__avatar" [ngClass]="'avatar-' + currentUser.role">
                {{ getUserInitial(currentUser.name) }}
              </div>
              <div class="user-info__details">
                <p class="user-info__name">{{ currentUser.name }}</p>
                <span class="role-badge" [ngClass]="'role-badge--' + currentUser.role">
                  {{ currentUser.role | uppercase }}
                </span>
              </div>
            </div>

            <button
              class="logout-btn"
              (click)="logout()"
              title="Logout"
              aria-label="Logout from application"
            >
              <svg
                class="logout-btn__icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span class="logout-btn__text">Logout</span>
            </button>
          }
        </nav>
      </div>
    </header>